import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import Layout from "../layout";
import { loadNews, selectNews } from "../../redux/modules/news";

const NewsItem = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const news = useSelector((state) => state.news);
  let { detail } = useParams();
  const neewsItem = news.response && news.response.filter((item) => item.link === detail)[0];

  useEffect(() => {
    document.title = `${neewsItem?.name} | Личный кабинет Брокера THE FIVE`;
    if (!news.loaded) dispatch(
      loadNews({
        cmd: 'news',
        _debug_token: auth.token
      })
    );
    
  }, []);

  const handleClick = (e) => {
    document.querySelector('.page__content').scrollTo(0, 0) 
  };
  
  return (
    <Layout>
      <div className="news-item">
        <div class="breadcrumbs">
          <Link to="/news">Назад к списку новостей</Link>
        </div>
        <div className="news-item-in">
          <div className="news-item__date" dangerouslySetInnerHTML={{__html: neewsItem?.date}}/>
          <div dangerouslySetInnerHTML={{ __html: neewsItem?.name }} className="news-item-tl" />
          <div
            style={{
              backgroundImage: `url('${neewsItem?.img}')`,
            }}
            className="news-item__image"
          ></div>
          <div dangerouslySetInnerHTML={{ __html: neewsItem?.text }} className="news-item__txt"></div>
          <div className="news-item__bt-wrap">
            {neewsItem?.prew && <Link to={`/news/${neewsItem?.prew}`} onClick={handleClick}>Предыдущая</Link>}
            {neewsItem?.next && <Link to={`/news/${neewsItem?.next}`} onClick={handleClick}>Следующая</Link>}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NewsItem;
